<template>
  <div>
    <top-bar heading="Role"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card header="Edit Role" no-body>
        <b-card-body class="p-3">
          <div class="row">
            <div class="col-6 col-lg-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="name">Name</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Name"
                      data-vv-name="name"
                      type="text"
                      placeholder="Name"
                      name="name"
                      id="name"
                      v-model="role.name"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('name')">{{ errors.first('name') }}</div>
            </div>
            <div class="col-6 col-lg-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="description">Description</label>
              <textarea :class="{'form-control': true, 'is-invalid': errors.has('description')}"
                        v-validate="'required'"
                        data-vv-delay="500"
                        data-vv-as="Description"
                        data-vv-name="description"
                        type="text"
                        placeholder="Description"
                        name="description"
                        id="description"
                        v-model="role.description"></textarea>
              <div class="invalid-tooltip d-block" v-if="errors.has('description')">{{ errors.first('description') }}</div>
            </div>
            <div class="col-6 col-lg-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9" for="level">Level</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('level')}"
                      v-validate="'required|numeric'"
                      data-vv-delay="500"
                      data-vv-as="Level"
                      data-vv-name="level"
                      type="number"
                      placeholder="Level"
                      name="level"
                      id="level"
                      v-model="role.level"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('level')">{{ errors.first('level') }}</div>
            </div>
            <div class="col-12 mb-3">
              <label class="control-label visible-ie8 visible-ie9 d-block" for="user_guide">User Guide</label>
              <b-form-file v-model="role.user_guide" accept=".pdf"></b-form-file>
            </div>
          </div>
          <div class="col-12">
            <loading-button :loading="loading" variant="primary" block @submit="submit" :disabled="errors.any()"></loading-button>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleEdit',
  data () {
    return {
      role: {},
      loaded: false,
      loading: false
    };
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(res => {
        if (!res) {
          return;
        }
        this.loading = true;

        let formData = new FormData();
        formData.append('_method', 'PUT');
        Object.keys(this.role).forEach(key => {
          formData.append(key, this.role[key]);
        });

        this.axios.post('/roles/' + this.id, formData).then(rsp => {
          this.$swal('Success', 'Role Updated', 'success');
          this.role = rsp.data.data;
          this.loading = false;
        }).catch(err => this.$errorOut(err));
      });
    }
  },
  mounted () {
    this.axios.get('/roles/' + this.id).then(rsp => {
      this.loaded = true;
      this.role = rsp.data.data;
    });
  },
  metaInfo: {
    title: 'Role'
  },
  props: ['id']
};
</script>
